import React, { useState, useCallback } from 'react';

import { useDomainVerification } from '../../context';
import StepContent from './StepContent';

const DNS_CHECKLIST = [
  'You will now land on a DNS Verification page. On this page, you will need to copy the TXT record provided',
  'You will now want to paste your TXT record in the box below',
];

const DNS_HELPER_TEXT = 'Add a DNS TXT record to your dommain host to prove that you own the domain.';

export const DnsInput = () => {
  const { verifyDNS } = useDomainVerification();
  const [record, setRecord] = useState('');

  const handleChange = useCallback(e => setRecord(e.target.value), []);
  const handleSubmit = useCallback((e) => {
    e.preventDefault();
    verifyDNS(record);
  }, [record, verifyDNS]);

  return (
    <StepContent
      title="Step 2"
      helperText={DNS_HELPER_TEXT}
      checklist={DNS_CHECKLIST}
      backEnabled
    >
      <form className="verification-dns-input" onSubmit={handleSubmit}>
        <textarea
          value={record}
          placeholder="facebook-domain-verification=378sgg929adjfk29tgjxsjfdsa"
          onChange={handleChange}
        />
        <button className={`verification-col-right-button ${record ? '' : 'disabled'}`} disabled={record === ''} type="submit">Submit</button>
      </form>
    </StepContent>
  );
};
